export function useCommandHandlers(onCommandChange, onAddCommand) {
  const handleInputChange = (command, value) => {
    onCommandChange(prev => ({ ...prev, [command]: value }));
  };

  const handleClear = (command) => {
    onCommandChange(prev => ({ ...prev, [command]: '' }));
  };

  const handleAdd = (command, type, value, readonly, placeholder) => {
    onAddCommand(command, type, value, readonly, placeholder);
  };

  return { handleInputChange, handleClear, handleAdd };
}